const getConfig = state => state?.settings?.config?.data;
const getConfigStatus = state => state?.settings?.config?.status;

export { getConfig, getConfigStatus };
